import { For, Show, onMount } from "solid-js";
import { Progress } from "../components/progress";
import { A, Link, useRouteData } from "@solidjs/router";
import { LivingArtistArtwork, Step2Data, UserSession } from "../types";
import { Artwork } from "../components/artwork";
import { fetchGet } from "../library/common";
import { Button } from "solid-bootstrap";
import toast from "solid-toast";
import { getArtworksCountJson, loadStep2Cms, max, min } from "../app";
import { createStore } from "solid-js/store";
import { CMS } from "../components/cms/cms";
import { MultiProgress } from "../components/multi-progress";
import { PageLoading } from "../components/page-loading";

type State = {
    isContentReady: boolean;
}
export function Step2() {

    const [session, setSession] = createStore<UserSession>({ } as UserSession);
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [artworks, setArtworks] = createStore<LivingArtistArtwork[]>([]);
    const count = () => artworks.length;
    const canApply = true;
    const toastSuccess = (msg: string) => {
        toast.success(msg);
    }
    const toastError = (msg: string) => {
        toast.error(msg);
    }
    const onDeleteClicked = async (id: string) => {
        const params = { id };
        const response = await fetchGet("/LivingArtistApplication/DeleteArtworkJson", params);
        const json = await response.json();
        if (!json.Success) {
            return toastError("Unable to remove the artwork from your application at this time.");
        }
        const remaining = artworks.filter(x => x.Id != id);
        setArtworks(remaining);
        await getArtworksCountJson({ forceRefresh: true });
        toastSuccess("The artwork has been removed from your application.")
    };
    onMount(async() =>{
        const routeData = await useRouteData() as Step2Data;
        await loadStep2Cms();
        setSession(routeData.session);
        setArtworks(routeData.artworks);
        setState({ isContentReady: true });
    })
    
    return (
        <Show when={state.isContentReady} fallback={<PageLoading />}>
            <div>
                <Progress step={2}></Progress>
                <Show when={canApply}>
                    <div class="row ">
                        <div class="col-md-8">
                        <p style="font-size: 1.5em;">
                            A minimum of {min} and a maximum of {max} images of the entrant's finest works. This may be submitted in the form of high-resolution digital images as JPEG or PNG files supplied.
                        </p>
                        <p>
                            Image preparation: Each submitted image must include the title of artwork, medium used to create the artwork, date, and dimensions.
                        </p>
                        <p>
                            Sculptors must submit 2 images of each sculpture from different views.
                        </p>
                        </div>
                        <div class="col-md-4">
                            <div class="pull-right">
                                <div>
                                    <MultiProgress value={count} min={min} max={max} />
                                </div>
                                <div style="font-size: 1.25em;">
                                    <b style="color: green;">{count()}</b> {count() == 1 ? "artwork" : "artworks"} added
                                </div>
                                <Show when={min - count() >= 0}>
                                    <div style="font-size: 1.25em;">
                                        <b style="color: red;">{min - count()}</b> more artworks required
                                    </div>
                                </Show>
                                <div style="font-size: 1.25em;">
                                    <b style="color: orange;">{max - count()}</b> more artworks available
                                </div>
                                <div style="margin-top: 40px;">
                                    <Link class="btn btn-chunky-lg btn-chunky-dark-grey" href={"/step-1"} style={{ "margin-right": "10px"}}>
                                        <CMS id="button::back" text>Back</CMS>
                                    </Link>
                                    <Show when={count() >= min}>
                                        <A class="btn btn-chunky-lg btn-chunky-goldenrod" href={"/step-3"}><CMS id="button::next" text>Next</CMS></A>
                                    </Show>
                                    <Show when={count() < min}>
                                        <CMS id="button::next" text>Next</CMS>
                                    </Show>
                                </div>
                                <Show when={count() < max}>
                                    <div style="margin-top: 20px;">
                                        <Button variant="primary" size="lg" href={"#/add-artwork"}><span style="margin-right: 10px;" class="fa fa-plus-circle"></span> <CMS id="button::add-artwork" text>Add Artwork</CMS></Button>
                                    </div>
                                </Show>
                            </div>
                        </div>
                    </div>
                </Show>
                <div class="row">
                    <For each={artworks}>{(artwork) =>
                        <Artwork
                            resources={{ canApply }}
                            session={session}
                            deleteClicked={onDeleteClicked}
                            artwork={artwork}></Artwork>
                    }</For>
                    <Show when={count() < max}>
                        <div class="artwork-container add-artwork-container">
                            <div style="display: table; margin: 0 auto;">
                                <div style="display: table-row;">
                                    <div style="display: table-cell; height: 300px; vertical-align: middle;">
                                        <Link class="btn btn-success" style="font-size: 2em;" href={ "/add-artwork" }>
                                            <span style="margin-right: 10px;" class="fa fa-plus-circle"></span><CMS id="button::add-artwork" text>Add Artwork</CMS>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Show>
                </div>
            </div>
        </Show>
    )
}